import { makeStyles } from '@material-ui/core/styles'

import colors from '@galo-monitor/styles/colors'

export default makeStyles({
  container: {
    padding: 0
  },
  listItemIcon: {
    minWidth: 35
  },
  item: {
    '& > *': {
      color: `${ colors.black  } !important`,
      '& span': {
        fontSize: '0.9rem !important'
      }
    },
    '&:hover': {
      '& > *': {
        color: `${ colors.primary  } !important`,
        '& path': {
          fill: `${ colors.primary  } !important`
        }
      }
    }
  },
  danger: {
    '& > *': {
      color: `${ colors.red  } !important`,
      '& span': {
        fontSize: '0.9rem !important'
      }
    },
    '&:hover': {
      opacity: 0.8
    }
  }
})
